import React, { lazy } from 'react'
import { connect } from 'react-redux';
import '@/assets/styles/pages/reset-password/reset-password.scss'
import { STORAGE_KEY } from '@/constants/storage.key'
import { getSafeStorage } from '@/helpers/global'
import { withRouter } from 'react-router';
import Tips from '@/components/Tips/Tips'
import { loginAction } from '@/actions/auth'
import accountIcon from '@/assets/images/icons/loginids.png'
import codeIcon from '@/assets/images/icons/code.png'
import idesIcon from '@/assets/images/icons/loginid.png'
import phonenumberoremailIcon from '@/assets/images/icons/phonenumberoremail.png'
import { getSafe } from '@/helpers/global';
import { getCaptchaImg } from '@/helpers/global';
import { getFingerprint } from '@/helpers/global';
import { iTradeEnv } from '@/configurations/app-configs/iTrade.env';
import {resetPasswordAction} from '@/actions/auth/auth.action.js'
import { Validators } from '@/helpers/functions/validateFunction';
import icon_successIcon from '@/assets/images/icons/changepassword_success.png'
import icon_failIcon from '@/assets/images/icons/changepassword_fail.png'
import { DATE_PICKER_TYPE } from '@/constants/app';
import Dropdown from '@/components/Dropdown/Dropdown';


class ResetPassWord extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      remember: true,
      errorText: '',
      loginId: '',
      password: '',
	  identification:'',
      captcha: '',
      loading: true,
      securityImageKeySrc: null,
      isLoading: false,
      fingerprintInfo: getFingerprint(),
      email:"",
      confirmEmail:"",
      activeStep: 0,
      idType:'',
    checkNum:''
    }
  }


  changeLoginId = (e) => {
    this.setState({
      loginId: e.target.value
    })
  }
  
  changeIdentification = (e) => {
    this.setState({
      identification: e.target.value
    })
  }
  
  changeEmail = (e) => {
    this.setState({
      email: e.target.value
    })
  }

  changeConfirmEmail = (e) => {
    this.setState({
      confirmEmail: e.target.value
    })
  }

  changeCaptcha = (e) => {
    this.setState({
      captcha: e.target.value
    })
  }

  returnreset(){
    this.setState({
      activeStep: 0,
    })
  }

  returnlogin(){
    this.props.history.push('/')
  }
  
  changeCheckNum=(e)=>{
    // e.target.value = e.target.value.replace(/\D/g,'')
    this.setState({checkNum:e.target.value})
  }
  
  handleChangeIdType=(idType)=>{
    this.setState({idType : idType[0].value,checkNum:'',identification:''})
    document.getElementById('Identification').value=''
  }


  deleteCheckNum=(e)=>{
    if(e.key==='Backspace' && !this.checkNum.value){
      this.HKidIpt.focus()
    }
  }

  getData() {
    if (this.state.loginId && this.state.identification && this.state.email && this.state.confirmEmail && this.state.captcha) {
      if(this.state.idType === 'H') {
        if(!this.state.checkNum){
          this.validateContent()
          return
        }
      }
      const params = {
        loginID: this.state.loginId,
        IDNumber: this.state.checkNum ? `${this.state.identification}(${this.state.checkNum})` : this.state.identification,
        email: this.state.email,
        confirmEmail: this.state.confirmEmail,
        captcha: this.state.captcha,
        language: this.props.language.lang
      }
      this.props.resetPW(params, res => {
        if (res.errorCode !== 'OLS0000') {
          this.setState({ errorText: res.errorMessage })
          this.getCaptcha()
        } else {
          if (res.isSuccess === 'Y' && res.isSuccess !== null) {
            this.setState({
              errorText: '',
              activeStep: 2,
              isLoading: false
            })
          } else {
            this.setState({
              activeStep: 1,
              isLoading: false,
              errorText: ''
            })
            this.getCaptcha()
          }
        }
      })
    } else {
      this.validateContent()
      return
    }
    
}

loading = () => {
  this.setState({
    loading: false
  }, () => {
    setTimeout(() => {
      this.setState({
        loading: true
      })
    }, 500)
  })
}
checkEmail(){
  if (!Validators.email(this.state.email)) {
    this.setState({ errorText: getSafe(() =>this.props.language.reset_message_invalid_destination)});
    return;
  }else{
    this.setState({ errorText: ""});
    return;
  }
}
checkconfirmEmail(){
  if (this.state.email != this.state.confirmEmail) {
    this.setState({ errorText: getSafe(() =>this.props.language.reset_message_invalid_destination_confirmEmail)});
    return;
  }else if (!Validators.email(this.state.email)) {
    this.setState({ errorText: getSafe(() =>this.props.language.reset_message_invalid_destination)});
    return;
  }else{
    this.setState({ errorText: ""});
    return;
  }
}
validateContent = () => {
  this.props.clearErrorMessage();
  if (!this.state.loginId) {
    this.setState({
      errorText: getSafe(() => this.props.language.login_login_id_null_error)
    })
  } else if (!this.state.identification ) {
    this.setState({
      errorText: getSafe(() => this.props.language.login_identification_number_null_error)
    })
  }else if (!this.state.email||!Validators.email(this.state.email)) {
    this.setState({
      errorText: getSafe(() => this.props.language.reset_message_invalid_destination)
    })
  }else if (!this.state.confirmEmail) {
    this.setState({
      errorText: getSafe(() => this.props.language.reset_message_invalid_destination_confirmEmail)
    })
  } else if (!this.state.captcha) {
    this.setState({
      errorText: getSafe(() => this.props.language.login_captcha_null_error)
    })
  } else if (!this.state.checkNum && this.state.idType === 'H'){
    this.setState({
      errorText: getSafe(() => this.props.language.login_identification_number_null_error)
    })
  } else{
    this.setState({ errorText: ""});
    return;
  }
}
  componentDidMount() {
    this.getCaptcha();
    // document.addEventListener('keypress', this.enterPress)
    let data = getSafeStorage(STORAGE_KEY.REMEMBER_ME)
    if (data) {
      this.setState({
        historyData: JSON.parse(data)
      })
    }
    if(this.props.idTypeList[0]?.value){
      this.setState({idType : this.props.idTypeList[0].value})
    }
  }

  getCaptcha() {
    this.setState({
      securityImageKeySrc: getCaptchaImg()
    })
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.close)
  }
  componentDidUpdate(beforeProps, beforeState) {
    if (beforeProps.language !== this.props.language && this.state.errorText) {
      this.validateContent();
    }
    if(JSON.stringify(this.props.idTypeList) != JSON.stringify(beforeProps.idTypeList) && this.props.idTypeList){
      this.setState({idType : this.props.idTypeList[0].value})
    }
  }

  render() {
    let { loginId,captcha,  errorText, securityImageKeySrc,activeStep,confirmEmail,email,identification ,idType , itemList} = this.state
	  let { language,errorMessage , idTypeList , isMobile} = this.props;
    if(errorMessage){
      errorText = errorMessage;
    }
    return (
      <div className="ResetPassWord">
        <div className="login-box">
          {activeStep === 0 &&<div className="reset-box">
            <div className="title">{getSafe(() => language.reset_password)}</div>
          {errorText &&
            <Tips>
              {errorText}
            </Tips>}
            <div className="form-ipt">
              <label htmlFor="Loginid" className="ipt-left">
                <img src={accountIcon} alt={language.login_login_id}/>
              </label>
              <input
                value={loginId}
                onChange={(e) => { this.changeLoginId(e) }}
                autoComplete="off"
                id="Loginid"
                placeholder={getSafe(() => language.login_login_id)} />
            </div>
			<div className="form-ipt id-input">
        <Dropdown
          style={{ height: '100%', width:'120px' ,color:'#b2b2b2' }}
          innerRef={e => this.marketRef = e}
          selectedOptions={[idTypeList[0]]}
          options={idTypeList}
          onChange={this.handleChangeIdType}
          onMouseDown={(event)=>this.maintainfocus(event)}
        />
			  {idType !== 'H'?
        <input
			    // value={identification}
			    onChange={(e) => { this.changeIdentification(e) }}
			    autoComplete="off"
			    id="Identification"
			    placeholder={getSafe(() => language.login_identification_number)} />
          :
        <div className='hkid-ipt'>
          <input
          style={{width: isMobile ? '188px': '165px'}}
			    // value={identification}
			    onChange={(e) => { this.changeIdentification(e) }}
			    autoComplete="off"
			    id="Identification"
          ref={c=>this.HKidIpt=c}
			    placeholder={getSafe(() => language.login_identification_number)} />
          <div className='check-number-ipt'>
            <input
            maxlength='1'
            ref={c=>this.checkNum=c}
            // onKeyDown={(e)=>{this.deleteCheckNum(e)}}
            onChange={(e)=>{this.changeCheckNum(e)}}
            ></input>
            <label>(&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;)</label>
          </div>
        </div>
        }
			</div>
            <div className="form-ipt">
            <label htmlFor="Email" className="ipt-left">
              <img src={phonenumberoremailIcon} alt={language.reset_email_address}/>
            </label>
            <input
              value={email}
              onBlur={(e)=>{this.checkEmail(e)}}
              onChange={(e) => { this.changeEmail(e) }}
              autoComplete="off"
              id="Email"
              placeholder={getSafe(() => language.reset_email_address)} />
            </div>
            <div className="form-ipt">
              <label htmlFor="ConfirmEmail" className="ipt-left">
                <img src={phonenumberoremailIcon} alt={language.reset_confirm_email_address}/>
              </label>
              <input
              value={confirmEmail}
                onBlur={(e)=>{this.checkconfirmEmail(e)}}
                onChange={(e) => { this.changeConfirmEmail(e) }}
                autoComplete="off"
                id="ConfirmEmail"
                placeholder={getSafe(() => language.reset_confirm_email_address)} />
            </div>

            <div className="form-ipt overflow-hidden">
              <label htmlFor="Code" className="ipt-left">
                <img src={codeIcon} alt={language.login_verification_code}/>
              </label>
              <input id="Code" autocomplete="off" onChange={(e) => this.changeCaptcha(e)} autoComplete="new-password" placeholder={getSafe(() => language.login_verification_code)} type="text" />
              <div className="ipt-right">
                {this.state.loading &&
                <img className="captcha-img" onClick={() => this.getCaptcha()} src={securityImageKeySrc} alt="captcha" />}
              </div>
            </div>

            <div className="button-box">
              <button 
                style={{background:'gray'}}
                onClick={()=>this.returnlogin()}
                className="button">
                { getSafe(() => language.reset_button_cancel)}
              </button>
              <button
                className="button"
                onClick={() => this.getData()}
                > 
                { getSafe(() => language.reset_button_submit)}
              </button>
            </div>
          </div>}
            {activeStep === 1 && <div className="reset-box">
              <div className="title">{ getSafe(() => language.reset_password_result)}</div>
              <img src={icon_failIcon} className="autoImg"/>
              <div className="message">{ getSafe(() => language.reset_password_failed)}</div>
              <div className="message">{ getSafe(() => language.reset_please_contact_customer_serive)}</div>
              <button
                onClick={() => this.returnreset()}
              >{ getSafe(() => language.common_try_again)}</button>
              </div>}
            {activeStep === 2 && <div className="reset-box">
              <div className="title">{ getSafe(() => language.reset_password_result)}</div>
              <img src={icon_successIcon} className="autoImg"/>
              <div className="message">{ getSafe(() => language.reset_password_success)}</div>
              <div className="message">{ getSafe(() => language.reset_new_password_sent_to_your_email)}</div>
              <button
                onClick={()=>this.returnlogin()}
              >{ getSafe(() => language.common_ok)}</button>
              </div>}
          </div>
      </div >
    )
  }
}

export default withRouter(connect(
  state => ({
    language: state.app.language,
    isAuthenticated: state.auth.isAuthenticated,
    appConfiguration: state.app.appConfiguration,
    idTypeList: state.app.idTypeList,
    isMobile: state.app.isMobile,
  }),
  dispatch => ({
    loginAction: (p, c) => dispatch(loginAction(p, c)),
    resetPW: (p, c) => dispatch(resetPasswordAction(p, c))
  })
)(ResetPassWord))
